import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedClass: null,
  zoomLevel: 1,
  isPanelOpen: false,
  draggedClass: null,
  dragOverSlot: null, // { day, time }
  selectedLocation: null, // null = all locations, string = specific location
  highlightedStudent: null, // { id, ts } — set when jumping to a student from search
};

const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    setSelectedClass: (state, action) => {
      state.selectedClass = action.payload;
      state.isPanelOpen = action.payload !== null;
    },
    clearSelection: (state) => {
      state.selectedClass = null;
      state.isPanelOpen = false;
      state.highlightedStudent = null;
    },
    setHighlightedStudent: (state, action) => {
      // Expects { id, ts } (ts makes re-clicking the same student re-trigger) or null.
      state.highlightedStudent = action.payload;
    },
    setZoomLevel: (state, action) => {
      const newZoom = Math.max(0.5, Math.min(2, action.payload));
      state.zoomLevel = newZoom;
    },
    closePanel: (state) => {
      state.isPanelOpen = false;
      state.selectedClass = null;
      state.highlightedStudent = null;
    },
    setDraggedClass: (state, action) => {
      state.draggedClass = action.payload;
    },
    clearDraggedClass: (state) => {
      state.draggedClass = null;
      state.dragOverSlot = null;
    },
    setDragOverSlot: (state, action) => {
      state.dragOverSlot = action.payload;
    },
    setSelectedLocation: (state, action) => {
      state.selectedLocation = action.payload;
    },
  },
});

export const { setSelectedClass, clearSelection, setZoomLevel, closePanel, setDraggedClass, clearDraggedClass, setDragOverSlot, setSelectedLocation, setHighlightedStudent } = calendarSlice.actions;
export default calendarSlice.reducer;

